const validateEnv = () => {
  const requiredVariables = [
    "REACT_APP_URL",
    "REACT_APP_STRIPE_PRODUCT_KEY",
    "REACT_APP_STRIPE_PUBLIC_KEY",
    "REACT_APP_STRIPE_SECRET_KEY",
  ];
  const variables = process.env;

  requiredVariables.forEach((requiredVar) => {
    if (!variables[requiredVar]) {
      console.error(`Variable ${requiredVar} is missing.`);
    }
  });

  const _env = {
    REACT_APP_URL: process.env.REACT_APP_URL || "",
    REACT_APP_STRIPE_PRODUCT_KEY:
      process.env.REACT_APP_STRIPE_PRODUCT_KEY || "",
    REACT_APP_STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY || "",
    REACT_APP_STRIPE_SECRET_KEY: process.env.REACT_APP_STRIPE_SECRET_KEY || "",
  };

  return _env;
};

export const env = validateEnv();
